import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import LoadingSpinner from '../../atoms/LoadingSpinner';
import ProfileOverview from '../../organisms/ProfileOverview';
import userService from '../../../services/userService';
import { userProfileService } from '../../../services/userProfileService';
import { normalizeProfileUsername } from '../../../utils/profileRoutes';
import './index.scss';

const normalizePublicProfileRouteUsername = (value) => {
  if (typeof value !== 'string' || !value.startsWith('@')) {
    return null;
  }
  return normalizeProfileUsername(value.slice(1));
};

export default function PublicProfilePage() {
  const { profileUsername } = useParams();
  const normalizedUsername = normalizePublicProfileRouteUsername(profileUsername);
  const [user, setUser] = useState(null);
  const [state, setState] = useState('loading');

  useEffect(() => {
    let cancelled = false;
    setUser(null);
    if (!normalizedUsername) {
      setState('not-found');
      return undefined;
    }
    setState('loading');
    userService.fetchPublicUserByUsername(normalizedUsername)
      .then(async (resolvedUser) => {
        if (!resolvedUser?.id) {
          return null;
        }
        await userProfileService.getInternetProfile(resolvedUser.id);
        return resolvedUser;
      })
      .then((resolvedUser) => {
        if (cancelled) return;
        if (!resolvedUser?.id) {
          setState('not-found');
          return;
        }
        setUser(resolvedUser);
        setState('ready');
      })
      .catch(() => {
        if (!cancelled) {
          setState('not-found');
        }
      });
    return () => {
      cancelled = true;
    };
  }, [normalizedUsername]);

  if (state === 'loading') {
    return (
      <main className="public-page-status" aria-busy="true">
        <LoadingSpinner size={40} />
      </main>
    );
  }

  if (state !== 'ready' || !user?.id) {
    return (
      <main className="public-page-status">
        <h1>Profile not found</h1>
      </main>
    );
  }

  return (
    <ProfileOverview
      standalone
      userId={user.id}
      profileUsername={user.username || normalizedUsername}
      viewerIdOverride={null}
    />
  );
}
